import type {VoidFunctionComponent} from "react";
import React from "react";
import s from "./Playlist.module.scss";
import BackButton from "../common/BackButton";
import TabbedNavigation from "../tabbedNavigation/TabbedNavigation";
import {LibraryLessonCard} from "../cards/library-lesson-card/LibraryLessonCard";
import {ISongCard, SongCard} from "../common/song-card/SongCard";
import {usePlaylistResultsLogic} from "./PlaylistResults.logic";
import {PlaylistCard, PlaylistSongCard} from "../../client/models/playlist/PlaylistResponse";
import ZeroHeightLoadingAnimation2 from "../loadingAnimation/ZeroHeightLoadingAnimation2";

function calculateSongCardProps(card: PlaylistSongCard): ISongCard {
  return {
    artistName: card.artistName,
    songId: card.songId,
    thumbnailUrl: card.imageUrl,
    name: card.title,
    hasVideo: card.hasVideo,
    lessonCount: card.numberOfArrangements,
  };
}

function calculateKey(card: PlaylistCard): string {
  switch (card.type) {
    case "song":
      return `${card.type} ${card.songId}`;
    case "lesson":
      return `${card.type} ${card.lessonId}`;
  }
}

export interface IPlaylistItemsProps {
}

export const Playlist: VoidFunctionComponent<IPlaylistItemsProps> = ({}) => {
  const {
    isLoading,
    playlistResponse,
    isCheckingWhetherLessonIsAccessible,
    calculateLessonCardProps,
  } = usePlaylistResultsLogic();
  
  const loadingEl = isLoading || isCheckingWhetherLessonIsAccessible
    ? <ZeroHeightLoadingAnimation2/>
    : null;

  return (
    <div className={s.playlistItems}>
      <header className={s.header}>
        {loadingEl}
        <BackButton label={'Back'} useClassName={s.backButton} />
        <h1>{playlistResponse.title}</h1>
      </header>
      <main className={s.scrollableContent}>
        <div className={s.cards}>
          {playlistResponse.cards.map((card) => {
            switch (card.type) {
              case "song":
                return <SongCard {...calculateSongCardProps(card)} key={calculateKey(card)} />;
              case "lesson":
                return <LibraryLessonCard {...calculateLessonCardProps(card)} key={calculateKey(card)} />;
            }
          })}
        </div>
      </main>
      <footer className={s.footer}>
        <TabbedNavigation/>
      </footer>
    </div>
  );
}
